module.exports = __webpack_public_path__ + "img/captain.fc716372.svg";